import { lang, remCss, rgba, scssVariables } from '../helpers';
import { Link } from 'react-router-dom';
import { Logo, MCButton } from './basic';
import { BASE_ICONS } from './svg';
import React from 'react';

const style = {
  display: 'flex',
  backgroundColor: rgba(scssVariables['colors-mc-primary'], 0.2)
};

const FooterInfo = ({ isRotate = false, containerStyle = {} }) => {
  if (isRotate) {
    return (
      <div
        className={'mc-footer-info'}
        style={{
          ...style,
          alignItems: 'center',
          flexDirection: 'column',
          padding: remCss(30),
          gap: remCss(20)
        }}
      >
        <Link className={'mc-pointer mc-p10'} style={{ flex: 0 }} to={'/'}>
          <Logo logoProps={{ width: 60, height: 60 }} />
        </Link>
        <div className={'mc-value-424'}>{'Email : contact@lifeapp.com'}</div>
        <div className={'mc-flex-20'}>
          <Link to={'/privacypolicy'} className={'mc-value-424'}>
            {lang.t('Privacy Policy')}
          </Link>
          <Link to={'/privacypolicy'} className={'mc-value-424'}>
            {lang.t('Terms of use')}
          </Link>
        </div>
        <div className={'mc-flex-30'}>
          <MCButton iconname={BASE_ICONS.FACEBOOK} primary dark padding={10} width={60} />
          <MCButton iconname={BASE_ICONS.INSTAGRAM} primary dark padding={10} width={60} />
        </div>
      </div>
    );
  }
  return (
    <div className={'mc-footer-info'} style={style}>
      <div
        className={'mc-flex mc-flex-center mc-grow'}
        style={{ padding: remCss(60), ...containerStyle }}
      >
        <div className={'mc-flex-col mc-grow'} style={{ gap: remCss(18) }}>
          <div className={'mc-value-728'}>{'LifeApp'}</div>
          <div className={'mc-value-424'}>{'Email : contact@lifeapp.com'}</div>
        </div>
        <div className={'mc-flex-col mc-grow mc-flex-center'} style={{ gap: remCss(18) }}>
          <Link className={'mc-pointer mc-p10'} style={{ flex: 0 }} to={'/'}>
            <Logo logoProps={{ width: 60, height: 60 }} />
          </Link>
          <div className={'mc-flex-20 mc-text-center'}>
            <Link to={'/privacypolicy'} className={'mc-value-424'}>
              {lang.t('Privacy Policy')}
            </Link>
            <Link to={'/privacypolicy'} className={'mc-value-424'}>
              {lang.t('Terms of use')}
            </Link>
          </div>
        </div>
        <div className={'mc-flex-30 mc-grow'}>
          <div className={'mc-grow'} />
          <MCButton iconname={BASE_ICONS.FACEBOOK} primary dark padding={10} width={70} />
          <MCButton iconname={BASE_ICONS.INSTAGRAM} primary dark padding={10} width={70} />
        </div>
      </div>
    </div>
  );
};
export default FooterInfo;
